if (process.browser) {
  const msg = '%c Hola 👋! somos storylabs.dev 🚀'
  const styles = [
    'font-size: 16px',
    'font-family: monospace',
    'background: white',
    'display: inline-block',
    'color: black',
    'padding: 8px 19px',
    'border: 1px dashed;'
  ].join(';')
  console.log(msg, styles)
}
